export default "__VITE_ASSET__CGRaPGFu__"